import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';

function GeneralRegister() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [schoolName, setSchoolName] = useState("");
  const [taluka, setTaluka] = useState("");
  const [jilha, setJilha] = useState("");
  const language = localStorage.getItem('language') || 'English';
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [logoURL, setLogoURL] = useState(null);
  const [schoolData, setSchoolData] = useState(null);
  const [filter, setFilter] = useState("all"); // Filter state
  const [searchTerm, setSearchTerm] = useState("");


  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

  const fetchData = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          const filteredData = data.filter(student => student !== null);
          setData(filteredData);
        }
      };

      allRecords.onerror = (event) => {
        console.error('Error fetching student data from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchData();
  }, [udiseNumber]);

  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
            setSchoolName(data.schoolName);
            setTaluka(data.taluka);
            setJilha(data.jilha);
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };



  useEffect(() => {
    fetchSchoolData();
  }, [udiseNumber]);

  // Get the selected student ID from local storage
const selectedStudentId = localStorage.getItem("selectedStudentId") || '';
// Filter the data based on the selected student ID
const filteredData = data.filter(student => {
  const isActive = student.isActive !== false; // Check if student is active or if isActive is undefined
  const matchesFilter = filter === "all" || (filter === "active" ? isActive : !isActive);
  
  // If the search term is empty, return all students that match the filter
  if (searchTerm.trim() === "") {
    return matchesFilter;
  }

  // Ensure registerNo is defined before checking for matches
  const matchesSearch = student.registerNo && student.registerNo.toString().includes(searchTerm);
  
  // If a selected student ID exists, only show that student
  if (selectedStudentId) {
    return student.id === selectedStudentId; // Compare student ID with selectedStudentId
  }
  
  // Otherwise, show all matching records based on filter and search
  return matchesFilter && matchesSearch; // Only return true if both conditions are met
});


  const sortedData = filteredData
    .filter(student => student !== null) // Filter out any null entries
    .sort((a, b) => {
      const registerNoA = a.registerNo || ""; // Fallback to empty string if undefined
      const registerNoB = b.registerNo || ""; // Fallback to empty string if undefined
      return registerNoA.localeCompare(registerNoB, undefined, { numeric: true }); // Sort numerically
    });



const handlePrint = () => {
  const printContent = document.querySelector('.min-cont-of-pge'); // Adjust selector to match your layout

  if (printContent) {
    const cloneContent = printContent.cloneNode(true); // Clone the main content

    // Open a new window for printing
    const printWindow = window.open('', '', 'height=800,width=1000');
    printWindow.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: A4 landscape;
              margin: 3mm;
              padding: 15px;
              border: 1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              font-size: 16px;
            }
            th, td {
              border: 1px solid black;
              text-align: center;
              padding: 5px;
            }
            td {
              font-size: 16px;
            }
            th {
              background-color: #82CAFA;
            }
            .print-button {
              display: none;
            }
            .school-header-container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .school-header2 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 0 0 auto; /* Prevent this section from growing */
              margin-right: 10px;
            }
            .school-header2 img {
              max-height: 70px;
            }
            .school-header {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center; margin-left:-70px;
              flex: 1 1 auto; /* This makes the school header take available space */
            }
            .school-header h1 {
              font-size: 28px;
              margin: 5px 0;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .school-header .report-title {
              font-size: 20px;
              margin: 5px auto;
              font-weight: bold;
              border: 1px solid black;
              width: 200px;
              padding: 5px;
              text-align: center;
              border-radius: 10px;
              background-color: black;
              color: white;
            }
            .school-header .report-tit {
              font-size: 16px;
              margin: 5px auto;
              font-weight: bold;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="school-header-container">
           <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolData.schoolName}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData.taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData.jilha}
                  </div>
                <div class="report-title">
                  ${language === "English" ?"General Register Number 1" : "जनरल रजिस्टर क्रमांक १"}
                </div>
              </div>
            </div>
          </div>
          <style>
            .styled-table {
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
          </style>
          ${cloneContent.outerHTML}
        </body>
      </html>
`);
    printWindow.document.close();
  
    // Focus and print the window after the image is loaded
    if (logoURL) {
      const img = printWindow.document.querySelector('.school-header2 img');
      img.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
    } else {
      
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  } else {
    console.error('Content to print not found');
  }
};




  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {/* <Sidebar /> */}
      <div className='mb-5 main-content-of-page'>
      <style>
      {`
      

    @media print {
      .table th,
      .table td {
        background-color: transparent !important;
        -webkit-print-color-adjust: exact;
      }
        @page{
              margin:3mm;
              border:1px solid black;
              padding:10px;
              }
      .table thead tr:first-child th {
        background-color: #82CAFA !important; /* Set the background color for the first row */
      }
      .print-button {
        display: none;
      }
      .custom-heading-text {
        margin: -5px auto;
      }
    }
    
  `}
        </style>
        <center style={{ borderBottom: '0.5px solid gray', padding: '10px', marginBottom: '20px' }}>
          <div id="print-title" className="text-center" style={{ fontWeight: 'bold' }}></div>
          <div className="custom-heading" style={{ paddingBottom: '10px', marginTop: '-10px' }}>
            <h3 className='text-center mb-2' style={{ color:'#1B4332', fontWeight:'600'}}>
              {language === "English" ? "General Register Number 1" : "जनरल रजिस्टर क्रमांक १"}
            </h3>
          </div>
        </center>

        <button onClick={handlePrint} className="btn btn-primary float-end" style={{marginTop:'-60px', marginBottom:'5px'}}>Print</button>
      

          <div style={{marginBottom:'10px'}}>
        <label>Status:</label>
        <select style={{padding:'0', width:'120px', height:'35px', marginRight:'10px'}} value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>

        <input  style={{ height:'35px', padding:0, width:'200px'}} 
          type="text"
          placeholder="Search by Register No"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>


      <div className='min-cont-of-pge table-responsive'>
        <table className='table' style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', fontSize: '13px', textAlign: 'center' }}>
          <thead>
            <tr style={{ fontWeight: 'bold', fontSize: '15px' }}>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black', width: '30px' }}>
                {language === "English" ? "Sr. No." : "अ. क्र."}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Register Number" : "रजिस्टर क्रमांक"}<br />
                {language === "English" ? "Book Number" : "बूक क्रमांक"}<br />
                {language === "English" ? "PEN No" : "PEN No"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Student's Name" : "विद्यार्थ्याचे नाव"}<br />
                {language === "English" ? "Student ID" : "स्टुडंट आयडी"}<br />
                {language === "English" ? "Aadhar Number" : "आधार क्रमांक"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Mother's Name" : "आईचे नाव"}<br />
                {language === "English" ? "Nationality" : "राष्ट्रीयत्व"}<br />
                {language === "English" ? "Mother Tongue" : "मातृभाषा"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Religion" : "धर्म"}<br />
                {language === "English" ? "Caste" : "जात"}<br />
                {language === "English" ? "SubCaste" : "पोटजात"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Admission Date" : "प्रविष्ट दिनांक"}<br />
                {language === "English" ? "Gender" : "लिंग"}<br />
                {language === "English" ? "APAAR ID" : "अपार आयडी"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Birth Place" : "जन्मस्थळ"}<br />
                {language === "English" ? "State - Country" : "राज्य - देश"}<br />
                {language === "English" ? "Previous School" : "यापूर्वी शिकत असलेली शाळा"}
              </th>
              <th className='text-center' style={{ padding: '5px', border: '1px solid black' }}>
                {language === "English" ? "Date Of Birth In numbers and Words" : "जन्म दिनांक अंकी व अक्षरी"}<br />
                {language === "English" ? "Admission Class" : "प्रवेश घेतलेला वर्ग"}<br />
                {language === "English" ? "Current Class" : "सध्या शिकत असलेला वर्ग"}
              </th>
            </tr>

          </thead>
          <tbody>
          {sortedData.map((student, index) => {
              const isHighlighted = searchTerm.trim() !== "" && student.registerNo && student.registerNo.toString().includes(searchTerm);
              return (
                <tr key={index} className={isHighlighted ? 'highlighted-row' : ''}>
                <td style={{ padding: '5px 10px', border: '1px solid black', width: '30px' }}>{index + 1}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}>{student.registerNo || '-'}<br />{student.bookno || '-'}<br />{student.panId || '-'}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}>{(student.stdName || "") + " "+ (student.stdFather || "") + " " +  (student.stdSurname || "") || '-'} <br /> {student.studentId || '-'} <br /> {student.stdAdharNo || '-'}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}>{student.stdMother || '-'} <br /> {student.nationality || '-'} <br /> {student.motherTounge || '-'}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}>{student.religion || '-'} <br /> {student.caste || '-'} <br /> {student.subCaste || '-'}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}> {new Date(student.dateOfAdmission).toLocaleDateString('en-GB')}<br />{student.gender || '-'}<br />{student.aparId || '-'}</td>
                <td style={{ padding: '5px', border: '1px solid black' }}>{student.birthPlace || '-'} <br /> {student.state || '-'} -  {student.country || '-'} <br /> {student.prevSchool || '-'}</td>
<td style={{ padding: '5px', border: '1px solid black' }}>
  {(student.dob ? student.dob.split('-').reverse().join('-') : '-')} - {student.dobInWords || '-'} <br />
  {student.admissionClass || '-'} <br />
  {student.currentClass || '-'}
</td>
              </tr>
            );
          })}
        </tbody>
        </table>
</div>


      </div>
    </div>
  );
}

export default GeneralRegister;
